import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { guardRoute } from '../auth/guard.ts'
import { parseOnboardingStep, type OnboardingSearch } from '../data/club-onboarding.ts'
import { numericIdParam } from './params.ts'
import { rootRoute } from './root.tsx'

// The roster's guard lets the role in; whether these kits are the caller's the page asks
// (`canEditClubKits`) and the API answers. Under the root: no società page sits around it.
export const clubKitsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/clubs/$clubId/kits',
  params: numericIdParam('clubId'),
  validateSearch: (search: Record<string, unknown>): OnboardingSearch => ({
    onboarding: parseOnboardingStep(search.onboarding),
  }),
  beforeLoad: ({ context, location }) =>
    guardRoute({
      queryClient: context.queryClient,
      requiredRoles: ['club', 'coach'],
      currentPath: location.href,
    }),
  staticData: { opensOnHero: true },
  component: lazyRouteComponent(() => import('../pages/club-kits.tsx')),
})

/** The way in from the dashboard and the convocazione, which only a dirigente di società is shown. */
export function clubKitsLink(clubId: number) {
  return { to: '/clubs/$clubId/kits', params: { clubId } } as const
}
